import Actions from '../actions/actions';
import SuggestionsActions from '../actions/SuggestionsCRUDActions';
import SuggestionModel from '../model/SuggestionModel';

export const suggestionInitialState = {
  entities: [] as SuggestionModel[],
  loading: false,
  isRetrieved: false,
};

export default function company(state = suggestionInitialState, action: any) {
  switch (action.type) {
    case SuggestionsActions.busyAction:
      return {
        ...state,
        loading: true,
      };
    case SuggestionsActions.unbusyAction:
      return {
        ...state,
        loading: false,
      };
    case SuggestionsActions.retrievedAllAction: {
      return {
        ...state,
        isRetrieved: true,
        entities: action.entities,
      };
    }
    case Actions.RESET:
      return suggestionInitialState;
    default:
      return state;
  }
}
